
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 359 299"}},[_c('path',{attrs:{"fill":"#FF4F23","d":"M81.774 249.288L0 79.93 245.232 0 359 88.356 331.954 240.92 117.138 299z"}})])
      }
    
      }
    